export const FAHRENHEIT = 'FAHRENHEIT';
export const CELSIUS = 'CELSIUS';

export const DARK_MODE = 'DARK_MODE';
export const LIGHT_MODE = 'LIGHT_MODE';
export const DARK_COLOR = '#212529'
export const LIGHT_COLOR = '#FFFFFF'

export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const WEBSITE_URL = 'https://github.com/liorho/Lior-Hoshea-20-05-2020'
export const APP_NAME = "weatherly"

export const DEFAULT_CITY = { city: 'Tel Aviv', country: 'Israel', id: '215854' }

export const DELAY_INPUT_FETCH = 800;
